module.exports = {
	"banner": [
		"Welcome!",
		"My work is grounded in a deep curiosity both in code and the synergistic effects of collaboration.",
		"When I was a kid that meant the perfect Magic card to both disrupt a schoolmates pesky Goblin deck AND throw another counter on my win condition. Now I find wonder and energy in working with a diversity of minds and skills intersecting to create meaningful, lasting web applications",
		"My path to web development was fairly unconvention, with my appetite for discovery driving each turn along the way. Curiosity has been the common underpinning throughout my work across theatre, anthropology, film, and insurance, which has allowed me to develop a strong set of cross disciplinary skills. Web development has been the natural culmination of my love for language, creative design, and understanding the human experience."
	],
	"skills": [
		"Coming from the liberal and performing arts, I approach development through a creative lens with lateral problem-solving skills. I'm always challenging myself to consider how best to leverage my technical skills to create meaningful experiences for a given audience.",
		"At this stage in my career I am tenacious in my hunt for challenging and meaningful work, as well as a believer in craft as collaboration between the boundaries of client needs and my own skills and perspective.",
		"In my own time I experiment to fail upward striving to have the courage to, in the words of the great director and theorist Tadashi Suzuki, 'practice daily what you know is impossible'"
	],
	"contact": [
		"Thanks for visiting, if you have any questions or work inquiries please contact my phone or email!",
		"Email: rrichardsonv+site@gmail.com",
		"Phone: 773-599-0381"
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/json/copy.json
// module id = 33
// module chunks = 0